import MensajeWarning from "../../Mensajes/MensajeWarning";
import React from 'react'
export default function IE11Detector(){
    const isIE = /*@cc_on!@*/false || !!document.documentMode;

// Edge 20+
    const isEdge = !isIE && !!window.StyleMedia;

    //let texto= 'El Explorador que estas usando es un Internet Explorer 11 o inferior.'
    //texto=texto +'En estos momentos NO soportamos exploradores vintage. Prueba con otros más molones como '
    //texto=texto +'FireFox, o Chrome (de Google), o Safari. Fíjate que majos los de Google que te dan 15 gigas gratis en Drive'
    //texto=texto +' y te espían desde tu android sólo para darte un mejor servicio....'
    
    let texto= 'Esta aplicación no soporta Internet Explorer.'
    texto=texto +' Por favor, inténtelo con otro navegador como, por ejemplo, Firefox, Chrome, Chromium, Edge, etc. '

    const mensaje={data:texto};
                ;
    if (isIE)
     return <MensajeWarning mensaje={mensaje} ></MensajeWarning>

     return <div></div>
}